import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import ProductDescription from './ProductDescription';
import ProductShippingAndDelivery from './ProductShippingAndDelivery';
import ProductSpecification from './ProductSpecification';

const SpecificationTabsDesktop = (props) => {
  const description = props.productSpecifications.productDescription;
  const shippingInfo = props.productSpecifications.productShippingTemplate;
  const specification = props.productSpecifications.productSpecifications;
  const isB2b = props.isB2b;
  const showProductShippingInformation = props.showProductShippingInformation;

  const [activeTab, setActiveTab] = useState('description');

  return (
    <div className="product-specifications--desktop product-specifications">
      <div>
        <div className="[ product-specifications__tab-headers ] [ bold text-large color-grey-500 ]">
          <div
            className={activeTab == 'description' ? 'active' : ''}
            onClick={() => setActiveTab('description')}
          >
            {translate('product-specification.description')}
          </div>
          {!isB2b && showProductShippingInformation && (
            <div
              className={activeTab == 'shipping' ? 'active' : ''}
              onClick={() => setActiveTab('shipping')}
            >
              {translate('product-specification.shippingInfo')}
            </div>
          )}
        </div>
        <div className="product-specifications__tab-content">
          {activeTab == 'description' && (
            <ProductDescription description={description} />
          )}
          {activeTab == 'shipping' && (
            <ProductShippingAndDelivery shippingInfo={shippingInfo} />
          )}
        </div>
      </div>
      <div className="product-specifications__shipping">
        <div className="product-specifications__shipping-title [ bold text-large color-grey-900 ]">
          {translate('product-specification.specification')}
        </div>
        <ProductSpecification specification={specification} />
      </div>
    </div>
  );
};

export default SpecificationTabsDesktop;
